export type WhatsAppStatsPeriod = 'daily' | 'weekly' | 'monthly' | 'yearly' | 'custom';

export interface WhatsAppStatsQuery {
  period?: WhatsAppStatsPeriod;
  days?: number;
  startDate?: string;
  endDate?: string;
}

export function statsPeriodLabel(period: WhatsAppStatsPeriod): string {
  switch (period) {
    case 'daily':
      return 'Daily';
    case 'weekly':
      return 'Weekly';
    case 'monthly':
      return 'Monthly';
    case 'yearly':
      return 'Yearly';
    case 'custom':
      return 'Custom';
    default:
      return 'Monthly';
  }
}

export function statsMessagesLabel(query: WhatsAppStatsQuery): string {
  if (query.period === 'custom' && query.startDate && query.endDate) {
    return `Messages (${query.startDate} – ${query.endDate})`;
  }
  if (query.period) {
    return `Messages (${statsPeriodLabel(query.period).toLowerCase()})`;
  }
  if (query.days) {
    return `Messages (${query.days}d)`;
  }
  return 'Messages';
}

export function buildStatsQueryParams(query: WhatsAppStatsQuery): Record<string, string | number> {
  const params: Record<string, string | number> = {};
  if (query.period) {
    params.period = query.period;
    if (query.period === 'custom' && query.startDate && query.endDate) {
      params.startDate = query.startDate;
      params.endDate = query.endDate;
    }
  } else if (query.days) {
    params.days = query.days;
  } else {
    params.period = 'monthly';
  }
  return params;
}

export function isCustomStatsReady(query: WhatsAppStatsQuery): boolean {
  if (query.period !== 'custom') return true;
  return Boolean(query.startDate && query.endDate && query.startDate <= query.endDate);
}
